/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ChecklistStepImage } from './checklist-step-image';

export class ChecklistMultiChoiceOption {
  answerId: number;
  text: string;
  isSelected: boolean;
  photos: ChecklistStepImage[] = [];
  unInspected: boolean;
}
